import { httpSingleton } from '@/lib/http-client';
import { Tag } from '@/lib/models';

export const tagsService = {
	getTopicTagsByProgramId(programId: string) {
		return httpSingleton.orchestrateRequest<{ tags: Tag[] }>({
			method: 'GET',
			url: `/advisory-service/api/v1/tags/topic/${programId}`,
		});
	},
};
